import React, { ReactNode } from "react";
import { Button } from "@mui/material";
import { EmptyState } from "~/pages/inventory/components/EmptyState/EmptyState";
import { VulnerabilitiesIcon } from "~/icons";

type NoMatchFiltersProps = {
  onClick: () => void;
  title: string;
  content: string;
  icon?: ReactNode;
  contained?: boolean;
};

export const NoMatchFilters = ({
  onClick,
  content,
  title,
  icon,
  contained,
}: NoMatchFiltersProps) => {
  return (
    <EmptyState
      headline={title}
      icon={
        icon || (
          <VulnerabilitiesIcon sx={{ fontSize: 38, color: "primary.main" }} />
        )
      }
      textContent={content}
      contained={contained}
      actionButtons={
        <Button variant="outlined" color="error" onClick={onClick}>
          Reset filters
        </Button>
      }
    />
  );
};
